import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/core/Buttons/Button";
import { useTagManager } from "@/hooks/useTagManager";
import { requireAuthWithDevice } from "@/lib/guards";

export const Route = createFileRoute("/$locale/$partner/recycling/device-receipt-confirmation")({
	beforeLoad: requireAuthWithDevice,
	component: RecyclingDeviceReceiptConfirmation,
});

function RecyclingDeviceReceiptConfirmation() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { locale, partner } = useParams({ from: "/$locale/$partner" });
	const [loading, setLoading] = useState(false);

	useTagManager("Device Receipt Confirmation");

	return (
		<div className="mx-auto max-w-[81rem] text-center">
			<div className="mt-20 mb-32 flex items-center flex-col max-w-lg mx-auto">
				<h1 className="text-3xl font-semibold mb-12">{t("DeviceConfirmation.Device Recycling")}</h1>
				<p>{t("DeviceConfirmation.Confirm that you have received the device and complete the recycling process.")}</p>
				<div className="w-fit mt-12 mx-auto">
					<Button
						label={t("Buttons.Verify")}
						loading={loading}
						disabled={loading}
						onClick={() => {
							setLoading(true);
							navigate({ to: "/$locale/$partner/recycling/form", params: { locale, partner } });
						}}
					/>
				</div>
			</div>
		</div>
	);
}
